export interface LoggerInterface {
  debug: (params: { message: string; data?: unknown }) => void;
  info: (params: { message: string; data?: unknown }) => void;
  warn: (params: { message: string; data?: unknown }) => void;
  error: (params: { message: string; data?: unknown; error?: unknown }) => void;
  fatal: (params: { message: string; data?: unknown; error?: unknown }) => void;
}

// Simple console logger as fallback
const consoleLogger: LoggerInterface = {
  // oxlint-disable no-console -- intentional console fallback logger
  debug: ({ message, data }) => console.debug(message, data),
  info: ({ message, data }) => console.info(message, data),
  warn: ({ message, data }) => console.warn(message, data),
  error: ({ message, data, error }) => console.error(message, data, error),
  fatal: ({ message, data, error }) =>
    console.error('[FATAL]', message, data, error),
  // oxlint-enable no-console
};

let currentLogger = consoleLogger;

export const Logger = {
  setLogger: (logger: LoggerInterface): void => {
    currentLogger = logger;
  },
  debug: (params: { message: string; data?: unknown }): void =>
    currentLogger.debug(params),
  info: (params: { message: string; data?: unknown }): void =>
    currentLogger.info(params),
  warn: (params: { message: string; data?: unknown }): void =>
    currentLogger.warn(params),
  error: (params: { message: string; data?: unknown; error?: unknown }): void =>
    currentLogger.error(params),
  fatal: (params: { message: string; data?: unknown; error?: unknown }): void =>
    currentLogger.fatal(params),
};
